import type { Video } from "@/types";

export const videos: Video[] = [
  {
    id: "v001",
    title: "长风渡口",
    cover: "https://readdy.ai/api/search-image?query=ancient%20chinese%20river%20ferry%20dock%20at%20dusk%20with%20a%20lone%20boat%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v001&orientation=landscape",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    duration: "45分钟/集",
    tags: ["古装", "爱情", "剧情"],
    description: "乱世之中，渡口女子与落魄书生因一场误会结缘，从此携手走过烽火岁月。剧集以细腻的笔触描绘了小人物在时代洪流中的坚守与成长，画面考究、情感真挚。",
    categoryId: "drama",
    updateDate: "2024-09-28",
    views: "2.3亿",
    rating: "9.1",
    episode: "更新至32集",
  },
  {
    id: "v002",
    title: "迷雾追凶",
    cover: "https://readdy.ai/api/search-image?query=rainy%20neon%20city%20street%20at%20night%20with%20a%20lone%20detective%20silhouette%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v002&orientation=landscape",
    type: "电影",
    region: "中国大陆",
    year: 2023,
    duration: "118分钟",
    tags: ["悬疑", "犯罪", "剧情"],
    description: "一桩尘封十年的旧案，在连绵的雨夜中重新浮出水面。刑警队长循着蛛丝马迹抽丝剥茧，却发现自己也身处迷雾中心。",
    categoryId: "drama",
    updateDate: "2024-09-25",
    views: "1.6亿",
    rating: "8.7",
    episode: "正片",
  },
  {
    id: "v003",
    title: "都市晚风",
    cover: "https://readdy.ai/api/search-image?query=modern%20city%20skyline%20at%20blue%20hour%20with%20warm%20apartment%20windows%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v003&orientation=landscape",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    duration: "42分钟/集",
    tags: ["都市", "情感", "职场"],
    description: "三个在大城市打拼的年轻人，在晚风吹拂的天台上分享彼此的失落与梦想。真实细腻的都市群像，讲述普通人的温暖日常。",
    categoryId: "drama",
    updateDate: "2024-09-30",
    views: "9800万",
    rating: "8.4",
    episode: "更新至24集",
  },
  {
    id: "v004",
    title: "山海邮差",
    cover: "https://readdy.ai/api/search-image?query=lone%20postman%20walking%20a%20winding%20mountain%20road%20at%20sunrise%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v004&orientation=landscape",
    type: "电影",
    region: "中国大陆",
    year: 2022,
    duration: "126分钟",
    tags: ["剧情", "文艺", "公路"],
    description: "坚守山村邮路三十年的老邮差，在退休前的最后一次送信途中，重新找回了与这片山海的羁绊。一部关于坚守与告别的温情之作。",
    categoryId: "drama",
    updateDate: "2024-09-18",
    views: "7200万",
    rating: "8.9",
    episode: "正片",
  },
  {
    id: "v005",
    title: "归途列车",
    cover: "https://readdy.ai/api/search-image?query=old%20green%20train%20crossing%20a%20valley%20at%20golden%20hour%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v005&orientation=landscape",
    type: "电视剧",
    region: "中国香港",
    year: 2023,
    duration: "40分钟/集",
    tags: ["家庭", "剧情", "年代"],
    description: "一列开往故乡的列车，载着形形色色的旅人和各自的人生故事。车厢内外的人情冷暖，勾勒出一个时代的温暖记忆。",
    categoryId: "drama",
    updateDate: "2024-09-12",
    views: "6400万",
    rating: "8.6",
    episode: "全40集",
  },
  {
    id: "v006",
    title: "极夜行动",
    cover: "https://readdy.ai/api/search-image?query=sci-fi%20action%20scene%20with%20armored%20figure%20in%20snowy%20arctic%20night%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v006&orientation=landscape",
    type: "电影",
    region: "美国",
    year: 2024,
    duration: "132分钟",
    tags: ["动作", "科幻", "冒险"],
    description: "在极夜笼罩的北极基地，一支特别行动小队必须在有限时间内完成一项关乎人类未来的秘密任务。视觉震撼、节奏紧凑的科幻动作大片。",
    categoryId: "drama",
    updateDate: "2024-10-02",
    views: "1.9亿",
    rating: "8.3",
    episode: "正片",
  },
  {
    id: "v007",
    title: "星光大玩家",
    cover: "https://readdy.ai/api/search-image?query=glowing%20stage%20with%20spotlights%20and%20cheering%20crowd%20silhouette%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v007&orientation=landscape",
    type: "综艺",
    region: "中国大陆",
    year: 2024,
    duration: "90分钟/期",
    tags: ["竞技", "真人秀", "娱乐"],
    description: "全新明星竞技真人秀，八位常驻嘉宾在欢笑与泪水中完成一项项意想不到的挑战任务，展现真实又反差的一面。",
    categoryId: "variety",
    updateDate: "2024-10-05",
    views: "3.1亿",
    rating: "8.8",
    episode: "更新至第12期",
  },
  {
    id: "v008",
    title: "城市味蕾记",
    cover: "https://readdy.ai/api/search-image?query=steaming%20street%20food%20stall%20at%20night%20market%20with%20warm%20lanterns%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v008&orientation=landscape",
    type: "综艺",
    region: "中国大陆",
    year: 2024,
    duration: "60分钟/期",
    tags: ["美食", "旅行", "生活"],
    description: "跟着美食探店团走进城市最深处的烟火小巷，寻找那些藏于街角却令人魂牵梦萦的地道味道。",
    categoryId: "variety",
    updateDate: "2024-10-03",
    views: "1.4亿",
    rating: "8.5",
    episode: "更新至第8期",
  },
  {
    id: "v009",
    title: "音乐合伙人",
    cover: "https://readdy.ai/api/search-image?query=concert%20stage%20with%20microphone%20and%20colorful%20stage%20lights%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v009&orientation=landscape",
    type: "综艺",
    region: "中国大陆",
    year: 2023,
    duration: "75分钟/期",
    tags: ["音乐", "选秀", "竞技"],
    description: "实力唱将与新生代音乐人跨界合作，用一次次颠覆改编碰撞出令人惊艳的舞台。耳朵的饕餮盛宴，就在音乐合伙人。",
    categoryId: "variety",
    updateDate: "2024-09-20",
    views: "2.2亿",
    rating: "8.2",
    episode: "全14期",
  },
  {
    id: "v010",
    title: "周末喜剧社",
    cover: "https://readdy.ai/api/search-image?query=comedy%20club%20stage%20with%20red%20curtain%20and%20spotlight%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v010&orientation=landscape",
    type: "综艺",
    region: "中国大陆",
    year: 2024,
    duration: "80分钟/期",
    tags: ["喜剧", "脱口秀", "娱乐"],
    description: "每周为你奉上最新鲜的段子和最炸场的笑点，一群脱口秀演员用幽默解构生活，陪你度过轻松的周末时光。",
    categoryId: "variety",
    updateDate: "2024-10-06",
    views: "1.8亿",
    rating: "8.6",
    episode: "更新至第20期",
  },
  {
    id: "v011",
    title: "荒野生存家",
    cover: "https://readdy.ai/api/search-image?query=lone%20explorer%20camping%20under%20starry%20sky%20in%20wild%20mountains%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v011&orientation=landscape",
    type: "综艺",
    region: "中国大陆",
    year: 2023,
    duration: "70分钟/期",
    tags: ["户外", "冒险", "纪实"],
    description: "在没有信号的荒野里，嘉宾们需要依靠双手与智慧搭建庇护所、寻找食物，完成一场与自然对话的生存挑战。",
    categoryId: "variety",
    updateDate: "2024-09-15",
    views: "8600万",
    rating: "8.4",
    episode: "全10期",
  },
  {
    id: "v012",
    title: "深夜食铺",
    cover: "https://readdy.ai/api/search-image?query=tiny%20cozy%20midnight%20noodle%20shop%20with%20warm%20glowing%20lantern%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v012&orientation=landscape",
    type: "原创",
    region: "中国大陆",
    year: 2024,
    duration: "18分钟/集",
    tags: ["治愈", "美食", "生活"],
    description: "一家只在深夜营业的小小食铺，用一碗碗热腾腾的料理，温暖着每一个匆忙归家的都市夜归人。",
    categoryId: "original",
    updateDate: "2024-10-07",
    views: "3200万",
    rating: "9.0",
    episode: "更新至第6集",
  },
  {
    id: "v013",
    title: "城市观察日记",
    cover: "https://readdy.ai/api/search-image?query=city%20rooftop%20view%20at%20sunset%20with%20drone%20silhouette%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v013&orientation=landscape",
    type: "原创",
    region: "中国大陆",
    year: 2024,
    duration: "12分钟/集",
    tags: ["纪录", "城市", "Vlog"],
    description: "用镜头记录一座城市的呼吸，从清晨的第一缕阳光到深夜的最后一盏灯，捕捉生活中被忽略的美好瞬间。",
    categoryId: "original",
    updateDate: "2024-10-04",
    views: "2100万",
    rating: "8.7",
    episode: "更新至第9集",
  },
  {
    id: "v014",
    title: "手作时光",
    cover: "https://readdy.ai/api/search-image?query=craftsman%20hands%20working%20wood%20in%20warm%20workshop%20light%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v014&orientation=landscape",
    type: "原创",
    region: "中国大陆",
    year: 2023,
    duration: "15分钟/集",
    tags: ["手工", "生活", "治愈"],
    description: "走进手艺人的工作室，看一块木头、一团泥土如何在指尖慢慢成形。慢下来的时光里，藏着专注的力量。",
    categoryId: "original",
    updateDate: "2024-09-22",
    views: "1500万",
    rating: "8.8",
    episode: "全12集",
  },
  {
    id: "v015",
    title: "街角咖啡馆",
    cover: "https://readdy.ai/api/search-image?query=cozy%20corner%20cafe%20with%20rain%20on%20window%20and%20warm%20light%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v015&orientation=landscape",
    type: "原创",
    region: "中国大陆",
    year: 2024,
    duration: "20分钟/集",
    tags: ["剧情", "温情", "都市"],
    description: "一间开在街角的咖啡馆，见证了无数次的相遇与告别。每一个推门而入的客人，都带着自己的故事。",
    categoryId: "original",
    updateDate: "2024-10-01",
    views: "1800万",
    rating: "8.9",
    episode: "更新至第4集",
  },
  {
    id: "v016",
    title: "极客实验室",
    cover: "https://readdy.ai/api/search-image?query=futuristic%20tech%20lab%20with%20glowing%20circuits%20and%20holograms%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v016&orientation=landscape",
    type: "原创",
    region: "中国大陆",
    year: 2023,
    duration: "16分钟/集",
    tags: ["科技", "科普", "创意"],
    description: "一群年轻的极客用最有趣的方式解读前沿科技，把实验室里的高深知识变成人人看得懂的短视频。",
    categoryId: "original",
    updateDate: "2024-09-19",
    views: "980万",
    rating: "8.5",
    episode: "全8集",
  },
  {
    id: "v017",
    title: "星海旅人",
    cover: "https://readdy.ai/api/search-image?query=spaceship%20drifting%20through%20colorful%20nebula%20starfield%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v017&orientation=landscape",
    type: "动漫",
    region: "日本",
    year: 2024,
    duration: "24分钟/集",
    tags: ["科幻", "冒险", "热血"],
    description: "少年驾驶着古老的星际飞船，踏上寻找失散家人的旅程。浩瀚星海之间，每一颗星球都藏着未知的惊喜。",
    categoryId: "anime",
    updateDate: "2024-10-08",
    views: "2.6亿",
    rating: "9.2",
    episode: "更新至第10集",
  },
  {
    id: "v018",
    title: "云端小镇",
    cover: "https://readdy.ai/api/search-image?query=floating%20island%20town%20above%20the%20clouds%20at%20dawn%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v018&orientation=landscape",
    type: "动漫",
    region: "中国大陆",
    year: 2023,
    duration: "22分钟/集",
    tags: ["治愈", "奇幻", "日常"],
    description: "漂浮在云端的小镇上，住着一群会飞的居民。温柔细腻的画面与节奏，讲述关于友情、梦想与成长的治愈故事。",
    categoryId: "anime",
    updateDate: "2024-09-26",
    views: "1.1亿",
    rating: "9.0",
    episode: "全24集",
  },
  {
    id: "v019",
    title: "机甲纪元",
    cover: "https://readdy.ai/api/search-image?query=giant%20mecha%20robot%20standing%20in%20ruined%20futuristic%20city%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v019&orientation=landscape",
    type: "动漫",
    region: "日本",
    year: 2022,
    duration: "25分钟/集",
    tags: ["机甲", "热血", "战斗"],
    description: "在人类文明濒临崩塌的末世，一群少年驾驶员操控巨型机甲守护最后的家园。热血沸腾的战斗与羁绊在此展开。",
    categoryId: "anime",
    updateDate: "2024-09-10",
    views: "1.7亿",
    rating: "8.4",
    episode: "全26集",
  },
  {
    id: "v020",
    title: "森林物语",
    cover: "https://readdy.ai/api/search-image?query=magical%20forest%20with%20glowing%20spirits%20and%20ancient%20trees%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v020&orientation=landscape",
    type: "动漫",
    region: "中国大陆",
    year: 2024,
    duration: "20分钟/集",
    tags: ["奇幻", "家庭", "治愈"],
    description: "小女孩误入一片会说话的森林，与森林里的精灵伙伴一同守护家园。温暖治愈的画风，讲述人与自然和谐共处的童话。",
    categoryId: "anime",
    updateDate: "2024-10-03",
    views: "7600万",
    rating: "8.6",
    episode: "更新至第8集",
  },
  {
    id: "v021",
    title: "大地脉动",
    cover: "https://readdy.ai/api/search-image?query=vast%20grassland%20with%20migrating%20animals%20at%20sunrise%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v021&orientation=landscape",
    type: "纪录片",
    region: "中国大陆",
    year: 2023,
    duration: "50分钟/集",
    tags: ["自然", "生态", "纪实"],
    description: "跨越山川湖海，摄制组用四年时间记录下这片土地上最壮美的自然奇观与野生动物的生存故事。",
    categoryId: "documentary",
    updateDate: "2024-09-24",
    views: "9200万",
    rating: "9.3",
    episode: "全6集",
  },
  {
    id: "v022",
    title: "千年匠艺",
    cover: "https://readdy.ai/api/search-image?query=ancient%20chinese%20artisan%20carving%20jade%20in%20warm%20light%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v022&orientation=landscape",
    type: "纪录片",
    region: "中国大陆",
    year: 2022,
    duration: "45分钟/集",
    tags: ["人文", "历史", "非遗"],
    description: "走访散落民间的传统手艺人，记录那些延续千年的古老技艺。在一刀一刻、一针一线之间，感受匠心的传承。",
    categoryId: "documentary",
    updateDate: "2024-09-08",
    views: "6800万",
    rating: "9.1",
    episode: "全8集",
  },
  {
    id: "v023",
    title: "深海秘境",
    cover: "https://readdy.ai/api/search-image?query=deep%20ocean%20trench%20with%20glowing%20bioluminescent%20creatures%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v023&orientation=landscape",
    type: "纪录片",
    region: "英国",
    year: 2024,
    duration: "55分钟/集",
    tags: ["海洋", "探索", "科普"],
    description: "潜入阳光无法抵达的深海，探索地球上最神秘也最壮丽的未知世界。那些会发光的生命，正在讲述海洋的秘密。",
    categoryId: "documentary",
    updateDate: "2024-10-02",
    views: "1.3亿",
    rating: "9.4",
    episode: "更新至第5集",
  },
  {
    id: "v024",
    title: "城市之根",
    cover: "https://readdy.ai/api/search-image?query=old%20city%20alley%20with%20history%20and%20modern%20skyline%20behind%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v024&orientation=landscape",
    type: "纪录片",
    region: "中国大陆",
    year: 2023,
    duration: "48分钟/集",
    tags: ["城市", "人文", "历史"],
    description: "在拔地而起的摩天楼之间，依然保留着一条条记录城市记忆的老街巷。跟随镜头，寻找一座城市的根与魂。",
    categoryId: "documentary",
    updateDate: "2024-09-16",
    views: "5400万",
    rating: "8.9",
    episode: "全10集",
  },
  {
    id: "v025",
    title: "未央歌",
    cover: "https://readdy.ai/api/search-image?query=lone%20singer%20on%20a%20dimly%20lit%20music%20hall%20stage%20at%20night%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v025&orientation=landscape",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    duration: "44分钟/集",
    tags: ["年代", "爱情", "音乐"],
    description: "民国年间，一群热爱音乐的年轻人聚集在未央歌厅，用歌声对抗命运。华丽的舞台背后，是一段段令人动容的青春故事。",
    categoryId: "drama",
    updateDate: "2024-10-09",
    views: "1.2亿",
    rating: "8.8",
    episode: "更新至第18集",
  },
  {
    id: "v026",
    title: "一起去露营",
    cover: "https://readdy.ai/api/search-image?query=cozy%20campfire%20with%20tents%20by%20a%20lake%20at%20night%20under%20stars%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v026&orientation=landscape",
    type: "综艺",
    region: "中国大陆",
    year: 2024,
    duration: "85分钟/期",
    tags: ["户外", "真人秀", "治愈"],
    description: "卸下明星光环，几位好友驱车前往山野湖畔露营。生火、做饭、看星星，慢下来的相处里全是真实的温暖。",
    categoryId: "variety",
    updateDate: "2024-10-08",
    views: "1.5亿",
    rating: "8.7",
    episode: "更新至第9期",
  },
  {
    id: "v027",
    title: "声音档案",
    cover: "https://readdy.ai/api/search-image?query=vintage%20radio%20microphone%20in%20a%20warm%20dusty%20recording%20studio%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v027&orientation=landscape",
    type: "原创",
    region: "中国大陆",
    year: 2024,
    duration: "14分钟/集",
    tags: ["人文", "纪录", "声音"],
    description: "用声音记录正在消失的城市记忆——老巷的叫卖、渡口的汽笛、旧厂房的机器声，都是这座城市独一无二的档案。",
    categoryId: "original",
    updateDate: "2024-10-06",
    views: "1400万",
    rating: "8.9",
    episode: "更新至第5集",
  },
  {
    id: "v028",
    title: "墨色江湖",
    cover: "https://readdy.ai/api/search-image?query=ink%20wash%20painting%20of%20a%20swordsman%20on%20a%20misty%20mountain%20peak%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v028&orientation=landscape",
    type: "动漫",
    region: "中国大陆",
    year: 2024,
    duration: "23分钟/集",
    tags: ["武侠", "国风", "热血"],
    description: "水墨风格的国风武侠动画，少年剑客踏遍山河寻找失传的剑谱。每一帧都如流动的水墨长卷。",
    categoryId: "anime",
    updateDate: "2024-10-07",
    views: "9800万",
    rating: "9.0",
    episode: "更新至第12集",
  },
  {
    id: "v029",
    title: "山与海之间",
    cover: "https://readdy.ai/api/search-image?query=coastal%20fishing%20village%20between%20cliffs%20and%20ocean%20at%20golden%20hour%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v029&orientation=landscape",
    type: "纪录片",
    region: "中国大陆",
    year: 2024,
    duration: "50分钟/集",
    tags: ["自然", "人文", "旅行"],
    description: "沿着漫长的海岸线一路向南，记录依山傍海的村落与靠海为生的人们，讲述人与自然相依相存的动人故事。",
    categoryId: "documentary",
    updateDate: "2024-10-09",
    views: "7600万",
    rating: "9.2",
    episode: "更新至第4集",
  },
  {
    id: "v030",
    title: "第七个黎明",
    cover: "https://readdy.ai/api/search-image?query=ruined%20city%20at%20dawn%20with%20first%20light%20breaking%20through%20smoke%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=800&height=450&seq=jingpin-v030&orientation=landscape",
    type: "电影",
    region: "中国大陆",
    year: 2024,
    duration: "124分钟",
    tags: ["科幻", "剧情", "悬疑"],
    description: "当城市陷入永夜，七个陌生人必须在第七个黎明到来前找到真相。一部关于人性与希望的科幻悬疑佳作。",
    categoryId: "drama",
    updateDate: "2024-10-10",
    views: "2.1亿",
    rating: "8.9",
    episode: "正片",
  },
];